import { DEFAULT_LOCATIONS, AMAZON, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 2470d4b40ed8ac15b18f3ac98f660865b7adb665',
  staging: 'Token 7927045a583ce4f1c62ca6e951b9e9338ef38ea2',
  prod: 'Token ec41789fd67e2a4707e5662841fa6926bfe43008',
};

const token = selectToken(apiTokens);

const amazonConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'amazon-cigna',

  API_TOKEN: token,
  EMBOLD_CLIENT: AMAZON,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.ArlingtonVA },
  LOGIN_NETWORK_NAME: 'amazonUserId',

  // content
  DISPLAY_NAME: 'Amazon',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: true,
};

export default amazonConfig;
